<template lang="pug">
  #ReservationIndex.container-width
    h5.text-center.pb-2.letter-spacing-6 我要預約
    hr.border-primary.pb-2
    .content.customerInput
      ValidationObserver(
        ref="form"
        tag="form"
        @submit.stop.prevent="submitHandler"
      )
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValStore",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.store",
              tag-placeholder="輸入搜尋預約專門店",
              placeholder="請選擇預約專門店",
              selectedLabel="已選擇",
              :showLabels="false",
              selectLabel="",
              :searchable="false",
              open-direction="bottom",
              label="store_title",
              track-by="store_id",
              :options="reservationStores",
              deselectLabel="",
              :allow-empty="false"
              noOptions="無預約專門店"
              @select="getReservationTimeHandler"
              disabled
            )
              template(slot="noOptions")
                strong 無預約專門店
            div(
              id="input-name-live-feedback",
              v-show="form.store === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValActivity",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.experience",
              tag-placeholder="輸入搜尋互動體驗方式",
              :placeholder="form.store === ('' || null) ? '請先選擇專門店' : '請選擇互動體驗方式'",
              selectedLabel="已選擇",
              :showLabels="false",
              selectLabel="",
              :searchable="false",
              open-direction="bottom",
              label="title",
              track-by="id",
              :options="reservationExperience",
              deselectLabel="",
              :allow-empty="false"
              :disabled="reservationExperience.length === 1"
              noOptions="無預約互動體驗方式"
            )
              template(slot="noOptions")
                strong 無預約互動體驗方式
            div(
              id="input-name-live-feedback",
              v-show="form.activity === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValDate",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.date",
              tag-placeholder="輸入搜尋預約日期",
              placeholder="請選擇希望預約日期",
              selectedLabel="已選擇",
              :showLabels="false",
              selectLabel="",
              :searchable="false",
              open-direction="bottom",
              :options="reservationTimeList",
              deselectLabel="",
              :allow-empty="false"
              noOptions="無預約日期"
              @select="changeReservationSession()"
            )
              template(slot="noOptions")
                strong 無預約日期
            div(
              id="input-name-live-feedback",
              v-show="form.date === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValTimeId"
          )
            multiselect.padding-right-0(
              v-model="form.timeId",
              :showLabels="false",
              tag-placeholder="輸入搜尋預約時段",
              placeholder="請選擇希望預約時段",
              selectedLabel="已選擇",
              selectLabel="",
              :searchable="false",
              open-direction="bottom",
              label="activity_time",
              track-by="detail_id",
              :options="reservationSessionList",
              :allow-empty="false",
              noOptions="無預約時段",
              style="height: 45px;",
              @select='checkTIme',
            )
              template(slot="noOptions")
                strong 無可預約時段
            div(
              id="input-name-live-feedback",
              v-show="form.timeId === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValName"
          )
            b-form-input(
              id="lastName",
              type="text",
              required,
              trim,
              :state="validState('last_name')",
              v-model="form.last_name",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="出席貴賓姓",
              class="rounded-0 bg-light border-black text-center"
              disabled
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValName"
          )
            b-form-input(
              id="firstName",
              type="text",
              required,
              trim,
              :state="validState('first_name')",
              v-model="form.first_name",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="出席貴賓名",
              class="rounded-0 bg-light border-black text-center"
              disabled
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required|mobile",
            ref="inputValMobile",
            v-slot="{ errors }"
          )
            b-form-input(
              id="mobile",
              type="tel",
              required,
              trim,
              :state="validState('mobile')",
              v-model="form.mobile",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="請輸入行動電話"
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span {{ errors[0] }}
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValJoinPeople",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.companion",
              tag-placeholder="輸入搜尋參與人數",
              placeholder="請選擇參與人數",
              selectedLabel="已選擇",
              selectLabel="",
              :searchable="false",
              open-direction="bottom",
              :showLabels="false",
              label="text",
              track-by="id",
              deselectLabel="",
              :options="joinPeopleOption",
              :allow-empty="false"
              noOptions="無參與人數"
            )
              template(slot="noOptions")
                strong 無參與人數
            div(
              id="input-name-live-feedback",
              v-show="form.companion === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
        b-form-group
          b-form-textarea(
            id="m_note",
            type="text",
            rows="3",
            v-model="form.m_note",
            placeholder="輸入備註",
            disabled
          )
      .row.no-gutters
        .col-12
          button.btn.btn-block.btn-primary.text-center.rounded-0(
            type="button",
            @click="submitHandler()"
          ) 送出
</template>

<script>
import { mapState } from 'vuex';
import { M_RESERVATION_SUCCESS } from '@/router/member/reservation';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import $ from 'jquery';
import Swal from 'sweetalert2';

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化手機驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

const moment = require('moment');
const _ = require('lodash');

export default {
  name: 'event-activity-reservation-edit',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    id: {
      type: [String, Number]
    }
  },
  data() {
    return {
      form: {
        store: null,
        date: null,
        timeId: null,
        first_name: null,
        last_name: null,
        mobile: null,
        companion: null,
        m_note: null,
        experience: null
      },
      joinPeopleOption: [
        {
          id: 1, text: '1'
        },
        {
          id: 2, text: '2'
        }
      ],
      reservationExperience: [],
      reservationTimeList: [],
      reservationSessionList: []
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  async mounted() {
    const vm = this;
    $('#appHeader').removeClass('d-none');

    Swal.fire({
      allowOutsideClick: false,
      didOpen: function didOpen() {
        Swal.showLoading();
      }
    });

    vm.$store.dispatch('sa_event_activity_reservation/getEventActivityReservationEditDataHandler', vm.id).then(() => {
      vm.$store.dispatch('sa_event_activity_reservation/getEventStoreDropdownHandler', { id: vm.editData.activity_id }).then(() => {
        const storeKey = _.findKey(vm.reservationStores, (val) => val.store_id === vm.editData.store_id);
        vm.form.store = vm.reservationStores[storeKey];
        // 回填日期及時段
        vm.getReservationTimeHandler(vm.editData).then(() => {
          vm.form.date = vm.editData.activity_date;
          vm.changeReservationSession().then(() => {
            const timeKey = _.findKey(vm.reservationSessionList, (val) => val.detail_id === vm.editData.detail_id);
            vm.form.timeId = vm.reservationSessionList[timeKey];
          });
        });
        vm.form.first_name = vm.editData.chinese_first_name;
        vm.form.last_name = vm.editData.chinese_last_name;
        vm.form.mobile = vm.editData.mobile;
        vm.form.m_note = vm.editData.m_note;
        const companionKey = _.findKey(vm.joinPeopleOption, (val) => val.id === vm.editData.companion_number);
        vm.form.companion = vm.joinPeopleOption[companionKey];
        Swal.close();
      });
    });
  },
  methods: {
    moment() {
      return moment();
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      // 其餘統一判斷
      if (vm.form[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.form[key]);
        }
          return this.form[key] ? true : false;
      }
      return null;
    },
    getReservationTimeHandler(val) {
      return new Promise((resolve) => {
        const vm = this;
        // 清除場次時間設定
        vm.form.experience = null;
        vm.form.date = null;
        vm.form.timeId = null;
        vm.reservationExperience = [];
        vm.reservationTimeList = [];
        vm.reservationSessionList = [];
        // 後台設定 0 到店體驗 1 線上體驗 2 到店體驗+線上體驗
        vm.settingReservationExperience(val);

        vm.$nextTick(() => {
          vm.$swal.fire({
            title: '請稍候，\n取得該店可預約時段中',
            allowOutsideClick: false,
            willOpen: () => {
              this.$swal.showLoading();
            }
          });
        });

        const input = {
          activity_id: vm.editData.activity_id,
          store_id: val.store_id
        };
        // 取得預約時段
        vm.$store.dispatch('sa_event_activity_reservation/getReservationTimeListHandler', input).then((res) => {

          if (res.data.activity_date.length === 0) {
            vm.$swal.fire({
              icon: 'info',
              title: '此專門店無預約時段'
            });
          } else {
            // 過濾日期下拉選項
            vm.reservationTimeList = $.map(vm.reservationAllTimeList.activity_date, (value, key) => [key]);
            vm.$swal.close();
          }
          resolve();
        });
      });
    },
    settingReservationExperience(val) {
      const vm = this;
      switch (val.experience || val.origin_experience) {
        case 0:
          vm.reservationExperience = [{
            id: 0,
            title: '到店體驗'
          }];
          vm.form.experience = {
            id: 0,
            title: '到店體驗'
          };
          break;
        case 1:
          vm.reservationExperience = [{
            id: 1,
            title: '線上體驗'
          }];
          vm.form.experience = {
            id: 1,
            title: '線上體驗'
          };
          break;
        case 2:
          vm.reservationExperience = [{
            id: 0,
            title: '到店體驗'
          }, {
            id: 1,
            title: '線上體驗'
          }];
          break;
        default:
          break;
      }
    },
    changeReservationSession() {
      return new Promise((resolve) => {

        const vm = this;
        vm.form.timeId = null;
        setTimeout(() => {
          const allowed = [vm.form.date];
          // 過濾預約所選日期選項
          vm.reservationSessionList = Object.keys(vm.reservationAllTimeList.activity_date)
            .filter((key) => allowed.includes(key))
            .reduce((obj, key) => {
              obj[key] = vm.reservationAllTimeList.activity_date[key];
              return $.map(obj, (value, key) => value);
            }, {});
          resolve();
        }, 50);
      });
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        if (vm.form.store === null) {
          vm.form.store = '';
        }
        if (vm.form.experience === null) {
          vm.form.experience = '';
        }
        if (vm.form.date === null) {
          vm.form.date = '';
        }
        if (vm.form.timeId === null) {
          vm.form.timeId = '';
        }
        if (vm.form.first_name === null) {
          vm.form.first_name = '';
        }
        if (vm.form.last_name === null) {
          vm.form.last_name = '';
        }
        if (vm.form.mobile === null) {
          vm.form.mobile = '';
        }
        if (vm.form.companion === null) {
          vm.form.companion = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        const key = _.findKey(vm.reservationTimeList, (val) => val.id === vm.form.timeId.id);
              const now = moment().format('hh:mm');
              const beginTime = moment(vm.reservationTimeList[key].start_time, 'hh:mma');
              const endTime = moment(now, 'hh:mma');
              const today = moment().format('YYYY-MM-DD');
              const reservationDate = moment(vm.form.date).format('YYYY-MM-DD');

        if (moment(reservationDate).isBefore(today)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前日期'
          });
        } else if (vm.form.date === moment().format('YYYY-MM-DD') && beginTime.isBefore(endTime)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前時間'
          });
        } else {
          vm.$swal.fire({
            title: '請稍候，\n表單送出中',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          const sendData = {
            id: vm.id,
            store_id: vm.form.store.store_id,
            detail_id: vm.form.timeId.detail_id,
            first_name: vm.form.first_name,
            last_name: vm.form.last_name,
            mobile: vm.form.mobile,
            companion: vm.form.companion.id,
            m_note: vm.form.m_note,
            experience: vm.form.experience.id
          };

          vm.$store.dispatch('sa_event_activity_reservation/updateEventActivityReservationHandler', sendData)
            .then(() => {
              vm.$swal.fire({
                icon: 'success',
                title: '編輯成功'
              });
              vm.$router.back();
            });
        }
      }
    },
    checkTIme(val) {
      const vm = this;
      vm.$nextTick(() => {
        if (val.activity_time.substr(val.activity_time.length -5, 5) === '(已額滿)') {
          vm.$swal.fire({
            icon: 'error',
            title: '選取的時段已額滿'
          });
          vm.form.timeId = null;
        }
      });
    }
  },
  computed: {
    ...mapState({
      reservationsTypeList: (state) => state.sa_event_activity_reservation.reservationsTypeList,
      reservationAllTimeList: (state) => state.sa_event_activity_reservation.reservationAllTimeList,
      reservationStores: (state) => state.sa_event_activity_reservation.reservationStores,
      editData: (state) => state.sa_event_activity_reservation.editData,
    }),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('sa_my_customer/resetHandler');
    if (to.name !== 'sa-my-customer-index') {
      window.sessionStorage.removeItem('user');
      window.sessionStorage.removeItem('filter_type');
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
.customerInput {
  * {
    text-align: center;
  }
  input,
  select,
  .b-form-btn-label-control,
  .itemRow {
    border-radius: 0;
    border: 0;
    border-top: 1px solid #e8e8e8!important;
    border-bottom: 1px solid #e8e8e8!important;
    background-color: #FCFBFB;
    text-align: center;
    text-align-last: center;
    height: 45px;
    padding-right: 0;
    span {
      width: 100%;
    }
  }
}
</style>
<style>
  .multiselect__tags {
    padding-right: 0!important;
  }
  .date-custom label{
    margin-left: -1.25rem!important;
  }
</style>
